import { Box, Stack } from '@mui/material';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { InformationOutlinedIcon } from '@synergy/theme-next';
import { PaloNextThemeProvider } from '@synergy/theme-palo';
import { PoolTooltip, PoolTypography } from '@synergy/components-next';

import { ProductDetail } from '../overview/models/product-detail';

export interface ArticleNumberProps {
    productDetail: ProductDetail;
}

/**
 * The article number, where every other mask carries its document number.
 *
 * It carries no label of its own: it stands in the place the head row keeps
 * for the number on every mask, and "Artikelnummer" underneath only said
 * again what the position already says (06.10.2026). The size and colour come
 * from that place too, so the row stays one row.
 */
export const ArticleNumber = (props: ArticleNumberProps) => {
    const { productDetail } = props;

    return (
        <PaloNextThemeProvider>
            <Stack direction="row" gap={0.5} alignItems="center">
                <Box component="span">{productDetail.number}</Box>
                <PoolTooltip
                    variant="light"
                    title={
                        <Stack typography="body2">
                            <PoolTypography
                                typography="subtitle1"
                                component="span"
                                translationId="app.product.detail.info.title"
                                sx={{ mb: 1.5 }}
                            />
                            {productDetail.lastImportUpdateAt && (
                                <>
                                    <Box component="strong">
                                        <FormattedMessage id="app.product.detail.info.lastImport" />
                                    </Box>
                                    <Box sx={{ mb: 1 }}>
                                        <FormattedDate
                                            value={productDetail.lastImportUpdateAt}
                                            year="numeric"
                                            month="short"
                                            day="2-digit"
                                            hour="2-digit"
                                            minute="2-digit"
                                        />
                                    </Box>
                                </>
                            )}
                            <Box component="strong">
                                <FormattedMessage id="app.product.detail.info.createdAt" />
                            </Box>
                            <FormattedDate
                                value={productDetail.createdAt}
                                year="numeric"
                                month="short"
                                day="2-digit"
                                hour="2-digit"
                                minute="2-digit"
                            />
                        </Stack>
                    }
                    sx={{ display: 'flex' }}
                    PopperProps={{ sx: { minWidth: 270 } }}
                >
                    <InformationOutlinedIcon sx={{ fontSize: 16 }} />
                </PoolTooltip>
            </Stack>
        </PaloNextThemeProvider>
    );
};
